import { PostProperties } from "../types";
import image from "../img/lostGemRicardoVillalobos.jpg";

const post: PostProperties = {
  id: 34,
  title: "Ricardo Villalobos - Live DJ Session, Radio 3 (19.11.2006)",
  content: `Ricardo Villalobos is a Chilean-German DJ and producer, celebrated for his boundary-pushing approach to electronic music and his eclectic sonic palette. Quickly rising to a legendary status, this recording shows the true range which Ricardo has.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/ricardo-villalobos-live-dj-session-radio-3",
  category: "Lost Gem",
  translationsBg: {
    content: `Рикардо Вилалобос е чилийско-немски диджей и продуцент, известен с нестандартния си подход към електронната музика и еклектичната си звукова палитра. Бързо издигайки се до легендарен статус, този запис показва истинския диапазон, който Рикардо притежава.`,
  },
};

export default post;
